import { render, staticRenderFns } from "./Adult.vue?vue&type=template&id=507f1a80&scoped=true"
import script from "./Adult.vue?vue&type=script&lang=js"
export * from "./Adult.vue?vue&type=script&lang=js"
import style0 from "./Adult.vue?vue&type=style&index=0&id=507f1a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f1a80",
  null
  
)

export default component.exports